<template>
  <v-card dark color="primary">
    <v-layout wrap align-center px-2 py-1>
      <v-flex my-1>
        <div class="white--text" style="font-size:20px">
          {{promocion ? promocion.descripcion : $t('general.misc.promociones')}} 
        </div>
        <div v-if="inmueble && tipoModuloActual != 'listaInmuebles'" class="white--text">
          {{inmueble.descripcionLarga}}
        </div>
       
      </v-flex>
      <v-flex style="flex-grow:0">
          <v-btn 
          class="secondary black--text"
          dark
              v-if="tipoModuloActual == 'simplificada' && !enviada"
            @click.stop="enviarReserva()"
          >
          {{$t('reservaSimplificada.enviarReserva')}}
          </v-btn>

      </v-flex>
      <v-menu
        v-if="incrustado && idiomas.length > 1"
        transition="scale-transition" origin="top right" 
        offset-y nudge-top="-4" left
        style="margin-left:auto !important;"
        class="my-1"
      >
        <v-btn class="menuBtn ma-0" large flat slot="activator" :disabled="cambiandoIdioma" :loading="cambiandoIdioma">
          <span style="margin-right:8px">
            {{$t('general.idiomas.' + getIdioma)}}
          </span>
          <v-icon style="margin-right: 5px;" large class="custom-icon icon-language" />
        </v-btn>
        <v-list>
          <template v-for="(idioma, index) in idiomas">
            <v-list-tile
              :key="'language-' + idioma.value"
              @click="cambiarIdioma(idioma.value)"
            >
              <v-list-tile-title>{{ idioma.text }}</v-list-tile-title>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < idiomas.length"
              :key="'divider-' + idioma.value"
            />
          </template>
        </v-list>
      </v-menu>
      <v-menu 
        v-if="tipoModuloActual != 'simplificada' && items.length > 0"
        transition="scale-transition" origin="top right" 
        offset-y nudge-top="-4" left
        style="margin-left:auto !important;"
        class="my-1"
      >
        <v-btn class="menuBtn ma-0" large flat slot="activator">
          <span style="margin-right:5px">{{$t('cabecera.documentos')}}<br/>{{$t('cabecera.adicionales')}}</span>
          <v-icon style="margin-right: 5px" large class="custom-icon icon-file"/>
          <v-icon style="margin-top:20px;" small class="custom-icon icon-drop-down-arrow"/>
        </v-btn>
        <v-list>
          <template v-for="(item, index) in items">
            <v-list-tile
              :key="item.id"
              :href="item.url"
              target="_blank"
            >
              <v-list-tile-title>{{ item.nombre }}</v-list-tile-title>
            </v-list-tile>
            <v-divider
              v-if="index + 1 < items.length"
              :key="'divider-' + index"
            />
          </template>
        </v-list>
      </v-menu>
    </v-layout>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    tipoModuloActual: {
      type: String,
      required: true
    },
    enviada: {
      type: Boolean,
      default: false
    },
    incrustado: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      cambiandoIdioma: false
    }
  },
  computed: {
    ...mapGetters({
      inmueble: 'promociones/inmuebles/getActual',
      promocion: 'promociones/getActual',
      modulosOrden: 'modulosOrdenes/getActual',
      modulos: 'modulosOrdenes/modulos/getAll',
    }),
    items () {
      if (this.tipoModuloActual === 'registro' ||
        this.tipoModuloActual === 'listaInmuebles' ||
        this.tipoModuloActual === 'scoring') {
        return []
      }
      let docs = this.promocion.documentos.filter(x => {
        return x.tiposModulo.some(y => y.tipo === this.tipoModuloActual)
      }).map(x => {
        return {
          id: x.id,
          nombre: x.documento.nombre.slice(0, -1 - x.documento.extension.length),
          url: this.$apiCabecera(x)
        }
      })
      return docs
    },
    idiomas () {
      return this.getIdiomas.map(x => {
        return {
          value: x,
          text: this.$t('general.idiomas.' + x)
        }
      }).sort((a, b) => a.text.localeCompare(b.text.localeCompare))
    }
  },
  methods: {
    ...mapActions({
      setIdioma: 'login/cambiarIdioma',
      addAlert: 'alerts/add'
    }),
    enviarReserva () {
      this.$emit('enviarReserva')
    },
    async cambiarIdioma (v) {
      try {
        this.cambiandoIdioma = true
        await this.setIdioma(v)
      } catch (error) {
        console.log(error)
        this.addAlert({texto: error.message, color: 'error'})
      } finally {
        this.cambiandoIdioma = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-btn:hover:before {
      background-color: transparent
    }
  .menuBtn 
    padding-left: 8px !important
    padding-right: 8px !important
</style>



// WEBPACK FOOTER //
// src/components/Cabecera.vue